import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { nanoid } from "nanoid";

import "./Button.scss";

const INDENT_WIDTH = 8;
const HORIZONTAL_LINE_OFFSET = 6;

const Button = ({
  variant = "primary",
  block,
  disabled,
  children,
  ...props
}) => {
  const idRef = useRef(nanoid());
  const buttonRef = useRef(null);
  const backgroundRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const setButtonDimensions = useCallback(() => {
    const { width, height } = buttonRef.current.getBoundingClientRect();

    if (dimensions.width === width && dimensions.height === height) {
      return;
    }

    setDimensions({ width, height });
  }, [buttonRef, dimensions]);

  useEffect(() => {
    if (buttonRef.current) {
      setButtonDimensions();
    }
  });

  const { width, height } = dimensions;

  const backgroundPath = [
    "M0 0",
    `L${width} 0`, // From top left to top right
    `L${width - INDENT_WIDTH} ${height / 2}`, // From top right to right indent middle
    `L${width} ${height}`, // From right indent middle to bottom right
    `L0 ${height}`, // From bottom right to bottom left
    `L${INDENT_WIDTH} ${height / 2}`, // From bottom left to left indent middle
    `L0 0`, // From top right to bottom right
  ].join(" ");

  return (
    <button
      ref={buttonRef}
      className={classNames(
        "button",
        `button--${disabled ? "disabled" : variant}`,
        {
          "button--block": block,
        }
      )}
      disabled={disabled}
      {...props}
    >
      <div className="button__content">{children}</div>
      <svg className="button__background" ref={backgroundRef}>
        {/*<path d="M0 0 L138 0 L138 32 Z" fill="red" />*/}
        {dimensions && (
          <React.Fragment>
            <defs>
              <clipPath id={idRef.current}>
                <path d={backgroundPath} />
              </clipPath>
            </defs>

            <path className="button__background-path" d={backgroundPath} />
            <line
              className="button__background-horizontal-line"
              x1={0}
              x2={width}
              y1={HORIZONTAL_LINE_OFFSET}
              y2={HORIZONTAL_LINE_OFFSET}
              clipPath={`url(#${idRef.current})`}
            />
            <line
              className="button__background-horizontal-line"
              x1={0}
              x2={width}
              y1={height - HORIZONTAL_LINE_OFFSET}
              y2={height - HORIZONTAL_LINE_OFFSET}
              clipPath={`url(#${idRef.current})`}
            />
          </React.Fragment>
        )}
      </svg>
    </button>
  );
};

export default Button;
